"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.regionToUrlGammaDomainMapping = exports.regionToUrlBetaDomainMapping = exports.regionToUrlProdDomainMapping = exports.getEntityIdFromRegionalEntityKey = exports.regionToEntityKeyValue = exports.regionEnumOrdering = exports.regionOrdering = exports.getRegionLabel = exports.ADSP_SUPPORTED_REGIONS = exports.regionToRegionNameMap = void 0;
const Region_1 = require("../types/Region");
exports.regionToRegionNameMap = new Map();
exports.regionToRegionNameMap.set('NA', 'Americas');
exports.regionToRegionNameMap.set('APAC', 'APAC');
exports.regionToRegionNameMap.set('EU', 'EMEA');
exports.ADSP_SUPPORTED_REGIONS = [Region_1.Region.NA, Region_1.Region.EU, Region_1.Region.APAC];
const getRegionLabel = (regionId) => {
    return 'region-label-' + regionId.toLowerCase();
};
exports.getRegionLabel = getRegionLabel;
const regionOrdering = (a, b) => exports.ADSP_SUPPORTED_REGIONS.indexOf(a.regionId) -
    exports.ADSP_SUPPORTED_REGIONS.indexOf(b.regionId);
exports.regionOrdering = regionOrdering;
const regionEnumOrdering = (a, b) => exports.ADSP_SUPPORTED_REGIONS.indexOf(a) - exports.ADSP_SUPPORTED_REGIONS.indexOf(b);
exports.regionEnumOrdering = regionEnumOrdering;
const regionToEntityKeyValue = (entityKeys, region) => {
    switch (region) {
        case Region_1.Region.NA:
            return entityKeys.ADSP_SHADOW_ENTITY_ACI_NA;
        case Region_1.Region.EU:
            return entityKeys.ADSP_SHADOW_ENTITY_ACI_EU;
        case Region_1.Region.APAC:
            return entityKeys.ADSP_SHADOW_ENTITY_ACI_FE;
        default:
            return null;
    }
};
exports.regionToEntityKeyValue = regionToEntityKeyValue;
const getEntityIdFromRegionalEntityKey = (entityKeys, region) => {
    const switchToEntityId = (0, exports.regionToEntityKeyValue)(entityKeys, region);
    if (switchToEntityId && switchToEntityId.includes('amzn1.ads1.aa1.')) {
        return switchToEntityId.split('.').pop();
    }
    return;
};
exports.getEntityIdFromRegionalEntityKey = getEntityIdFromRegionalEntityKey;
exports.regionToUrlProdDomainMapping = new Map([
    [Region_1.Region.NA, '//advertising.amazon.com'],
    [Region_1.Region.EU, '//advertising.amazon.co.uk'],
    [Region_1.Region.APAC, '//advertising.amazon.co.jp'],
]);
exports.regionToUrlBetaDomainMapping = new Map([
    [Region_1.Region.NA, '//advertising.integ.amazon.com'],
    [Region_1.Region.EU, '//advertising-uk.integ.amazon.com'],
    [Region_1.Region.APAC, '//advertising-jp.integ.amazon.com'],
]);
exports.regionToUrlGammaDomainMapping = new Map([
    [Region_1.Region.NA, '//advertising-preprod.amazon.com'],
    [Region_1.Region.EU, '//advertising-uk-preprod.amazon.com'],
    [Region_1.Region.APAC, '//advertising-jp-preprod-pdx.pdx.proxy.amazon.com'],
]);
//# sourceMappingURL=regionUtils.js.map